import { api_base } from '../api';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import { router } from '../../routes/routes';
import { convertToUrl } from '../../scripts/convert_name';
import Store from '../store';
import {
	setRandomProducts,
	setCurrentProductParent,
	getCurrentProductRatings
} from '../../store/actions';

export const Products = {
	// ---- GET ALL ----

	get(page = 1, cb) {
		$.ajax({
			url: api_base + '/products?page=' + page,
			method: 'GET',
			headers: {
				Accept: "application/json",
			},

			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					return Products.get(++page, cb);
				}

				Store.state.loading_products = false;
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- GET BY ID ----

	getById(id, cb) {
		let products = Store.state.products;

		if (typeof(id) == 'number')
			return false;

		let url = id.split('-');
		let name = url[0].split('_').join(' ');
		let color = url[1].split('_').join(' ');
		let color2 = url[2];

		if (color2)
			color2 = color2.split('_').join(' ');

		let data = {
			name,
			color,
			color2
		};

		// Check if they are products in the store, if not make a
		// request to obtain that product.
		if (!products.length) {
			$.ajax({
				url: api_base + '/products/get/byNameNColors',
				method: 'POST',
				data: data,
				headers: {
					Accept: 'application/json'
				},

				success: function (res) {
					// let cat = 0;

					cb(res);

					// if (res.category.parents) {
					// 	cat = res.category.parents.id;
					// } else {
					// 	cat = res.category.id;
					// }

					setCurrentProductParent(Store, res.id);
					getCurrentProductRatings(Store, res.id);
					setRandomProducts(Store, res.category.id);
				},

				error: function (err) {
					if (err.status == 500) {
						return toast({
							title: 'Servidor',
							content: 'Problemas con el servidor.'
						});
					}

					toast({
						title: 'Producto',
						content: 'El producto no fue encontrado'
					});
					// console.log(err);
				}
			});
		} else {
			// Iterate in the products alocated in the store.
			for (var i = 0; i < products.length; i++) {
				if (convertToUrl(products[i]) == id) {
					// let cat = 0;

					// if (products[i].category.parents) {
					// 	cat = products[i].category.parents.id;
					// } else {
					// 	cat = products[i].category.id;
					// }

					setCurrentProductParent(Store, products[i].id);
					getCurrentProductRatings(Store, products[i].id);
					setRandomProducts(Store, products[i].category.id);
					return cb(products[i]);
				}
			}

			$.ajax({
				url: api_base + '/products/get/byNameNColors',
				method: 'POST',
				data: data,
				headers: {
					Accept: 'application/json'
				},

				success: function (res) {
					// let cat = 0;

					cb(res);

					// if (res.category.parents) {
					// 	cat = res.category.parents.id;
					// } else {
					// 	cat = res.category.id;
					// }

					setCurrentProductParent(Store, res.id);
					getCurrentProductRatings(Store, res.id);
					setRandomProducts(Store, res.category.id);
				},

				error: function (err) {
					if (err.status == 500) {
						return toast({
							title: 'Servidor',
							content: 'Problemas con el servidor.'
						});
					}

					toast({
						title: 'Producto',
						content: 'El producto no fue encontrado'
					});
					// console.log(err);
				}
			});
		}
	},

	getFullById(id, cb) {
		$.ajax({
			url: api_base + '/products/' + id,
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Producto',
					content: 'El producto no fue encontrado'
				});
			}
		});
	},

	// ---- CREATE ----

	create(user, product, form, cb) {
		let data = new FormData();
		let images = {};

		// Convert fedex able string to boolean.
		if (product.fedex_able) {
			product.fedex_able = 0;
		} else {
			product.fedex_able = 1;
		}

		for (var i = 0; i < product.images.length; i++) {
			images['images[' + i + ']'] = product.images[i];
		}
		// Delete property images.
		delete product.images;

		for (var k in product) {
			data.append(k, product[k]);
		}
		// Append the data.
		for (var k in images) {
			data.append(k, images[k]);
		}

		$.ajax({
			url: api_base + '/admin/products',
			method: 'POST',
			data: data,
			cache: false,
			processData: false,
			contentType: false,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				toast({
					title: 'Crear Producto',
					content: 'El producto se ha creado correctamente'
				});
				form.is_submited = false;
				router.go({ name: 'admin_products' });
				cb(res);
			},

			error: function (err) {
				form.is_submited = false;

				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				toast({
					title: 'Crear Producto',
					content: 'El producto no se ha creado (llena todos los campos).'
				});

				// console.log(err);
			}
		});
	},

	// ---- UPDATE ----

	update(user, product, form, cb) {
		let data = new FormData();
		let images = {};
		// Delete info_img.
		delete product.info_img;

		// Convert fedex able string to boolean.
		if (product.fedex_able) {
			product.fedex_able = 0;
		} else {
			product.fedex_able = 1;
		}

		for (var i = 0; i < product.images.length; i++) {
			images['images[' + i + ']'] = product.images[i];
		}
		// Delete property images.
		delete product.images;

		for (var k in product) {
			data.append(k, product[k]);
		}
		// Append the data.
		for (var k in images) {
			data.append(k, images[k]);
		}

		data.append('_method', 'PUT');

		$.ajax({
			url: api_base + '/admin/products/' + product.id,
			method: 'POST',
			data: data,
			cache: false,
			processData: false,
			contentType: false,
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Actualizacion Producto',
					content: 'El producto se ha actualizado correctamente.'
				});
				router.go({ name: 'admin_products' });
				form.is_submited = false;
			},

			error: function (err) {
				toast({
					title: 'Actualizacion Producto',
					content: 'El producto no se ha actualizado.'
				});
				form.is_submited = false;
				// console.log(err);
			}
		});
	},

	// ---- DELETE ----

	delete(data, product, cb) {
		$.ajax({
			url: api_base + '/admin/products/' + product.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Eliminar Producto',
					content: 'El producto ' + product.name + ' ha sido eliminado.'
				});
			},

			error: function (err) {
				toast({
					title: 'Eliminar Producto',
					content: 'Error al eliminar el producto.'
				});
				// console.log(err);
			}
		});
	},

	// ---- RATINGS ----

	ratings(id, cb) {
		$.ajax({
			url: api_base + '/products/' + id + '/ratings',
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- PARENT ----

	parent(id, cb) {
		$.ajax({
			url: api_base + '/products/parent/' + id,
			method: 'GET',

			success: function (res) {
				if (res.parent_) {
					Products.getFullById(res.parent_.id, res => {
						cb(res);
					});
				} else {
					cb(null);
				}
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- RANDOM ----

	random(id, cb) {
		$.ajax({
			url: api_base + '/products/randomByCategory/' + id,
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- FEATURED (HOME) ----

	featured(cb) {
		$.ajax({
			url: api_base + '/products/featured/get',
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

  special(cb) {
		$.ajax({
			url: api_base + '/products/special/get',
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

  new(cb) {
		$.ajax({
			url: api_base + '/products/new/get',
			method: 'GET',

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- NOTIFY ME ----
	notify (user, product, cb, email) {
		let request = {
			url: `${api_base}/notify/me/${product.id}${user.token ? `?email=${user.user.email}` : `?email=${email}`}`,
			method: 'GET',

			// Request complete handler.
			success (res) {
				cb(res)
			},

			// Request error handler.
			error (err) {
				if (err.state === 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor'
					})
				}

				if (err.status === 401) {
					return toast({
						title: 'Verificacion',
						content: 'Necesitas iniciar sesion para realizar esta accion'
					})
				}
			}
		}

		user.token && Object.assign(request, {
			headers: {
				Authorization: `Bearer ${user.token}`,
				Accept: 'application/json'
			}
		})

		$.ajax(request)
	}
};



// WEBPACK FOOTER //
// ./src/store/api/products.js